import { z } from 'zod';
import { MoneySchema } from './common.js';
const AmountLike = z.union([MoneySchema, z.coerce.number().nonnegative()]);
export const ChainStepSchema = z.object({
    stepNo: z.number().int().positive(),
    roleCode: z.string().min(1),
    roleLabel: z.string().min(1),
});
export const ApprovalTierSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    docType: z.string().min(1),
    branchId: z.uuid().nullable().optional(),
    departmentId: z.uuid().nullable().optional(),
    maxAmount: AmountLike.nullable(),
    roleCodes: z.array(z.string().min(1)),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const ReplaceApprovalTiersSchema = z.object({
    docType: z.string().min(1).max(16),
    tiers: z
        .array(z.object({
        branchId: z.uuid().nullable().optional(),
        departmentId: z.uuid().nullable().optional(),
        maxAmount: z.coerce.number().positive().nullable(),
        roleCodes: z.array(z.string().min(1)).min(1),
    }))
        .min(1),
});
//# sourceMappingURL=approval-matrix.js.map